 <template>
  <div
    id="downloadPhaseModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group">
                      <label class="label-required">รหัสอ้างอิง:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control'"
                        :id="'DlbRefno'"
                        :name="'DlbRefno'"
                        :select2-options="DlbRefnoOptions"
                        :multiple="true"
                        v-model="DlbRefno"
                        ref="DlbRefnoSelect2"
                      ></select2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> ดาวน์โหลด
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2
  },
  data: function() {
    var self = this;
    return {
      DlbRefno: [],
      DlbRefnoOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MachineTransaction/Select2RefCode",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#downloadPhaseModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      let router = this.$router;

      axios({
        method: "post",
        url: "/Api/MachineTransaction/Download",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: null,
          ProductTypeId: [],
          AssetOwnerId: [],
          WarrantyTime: null,
          RefCode: this.DlbRefno
        }
      })
        .then(function(response) {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          $("#DlbRefno")
            .val("")
            .trigger("change");
          KTApp.unblockPage();
        });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    // set validation rules
    $("#downloadPhaseModal form").validate({
      rules: { DlbRefno: "required" },
      messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" }
    });

    $("#downloadPhaseModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/MachineTransaction/DownloadMachineTransaction.vue